import axios from 'axios';
import { useEffect, useRef, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { GamePlayerContext, LocalPlayerContext, NotificationContext } from '../../context/game-context';
import { useAuthBasicService } from '../../../blockhain/provider/initiate.provider';
import { Alert } from 'react-bootstrap';

export const AccountLogin = ({ setCurrentStep, playAsGuest }) => {
    const [username, setUsername] = useState('');
    const [otp, setOtp] = useState('');
    const [password, setPassword] = useState('');
    const [disabledButtonLogin, setDisabledButtonLogin] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [successMsg, setSuccessMsg] = useState('');
    const loginData = useRef(null);

    const {
        isAuthenticated,
        setupAccountData,
        user,
    } = useAuthBasicService();

    const updateLocalPlayerSetting = LocalPlayerContext((state) => state.updateLocalPlayerSetting);
    const setGamePlayerContext = GamePlayerContext((state) => state.setGamePlayerContext);

    useEffect(() => {
        if (isAuthenticated) {
            updateLocalPlayerSetting({ displayName: user.name, ...user });
            setGamePlayerContext({ isAccountBinded: user.isAccountBinded, isProfileUpdated: user.isProfileUpdated })
            // add your logic here
            // console.log(isAuthenticated, "EFFECT AUTHENTICATED CHANGED")
        } else {
            // setUserLogged(null)
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAuthenticated]);
    const login = async (e) => {
        e.preventDefault();
        // const isEmailValid = validateEmail(email);
        // if (!isEmailValid)
        //     addToast({ title: "Email Invalid", message: "Please enter a valid email", type: "danger" });

        setDisabledButtonLogin(true);
        setErrorMsg('');

        try {
            const login = await axios.post(`${process.env.API_URL}/auth/login_email`, { username, password }, {
                crossDomain: true
            });
            setSuccessMsg("Login success! You'll redirect to United Tractor Virtual Museum");
            setCurrentStep('validate-otp')
            loginData.current = login.data;
            setupAccountData(loginData.current);
            // await setupCustodialWallet(login.data);
            setDisabledButtonLogin(false);
        } catch (err) {

            setDisabledButtonLogin(false);
            // addToast({ title: "Error", message: err.response.data.message, type: "danger" });
            setErrorMsg(err.response.data.message);

        }
    }

    return (
        <>
            <h5 className='my-3 fw-bold'>
                United Tractors Museum Virtual
            </h5>
            <hr />
            <div className='row p-0 text-start mb-3'>
                {errorMsg != '' && <Alert variant="danger"><div dangerouslySetInnerHTML={{ __html: errorMsg }} /></Alert>}
                {successMsg != '' && <Alert variant="success">{successMsg}</Alert>}
                <Form onSubmit={login} className={'p-0'}>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Username</Form.Label>
                        <Form.Control type="text" placeholder="Enter Username" onChange={(e) => setUsername(e.target.value)} />
                        {/* <Form.Text className="text-muted">
                            We'll never share your email with anyone else.
                        </Form.Text> */}
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formBasicPassword">
                        <Form.Label>Password</Form.Label>
                        <Form.Control type="password" placeholder="Password" onChange={(e) => setPassword(e.target.value)} />
                    </Form.Group>
                    <Button variant="primary" type="submit" disabled={disabledButtonLogin} className={"btn-primary w-100"}>
                        Log In
                    </Button>
                </Form>
            </div>
            <hr />
            <Button variant="outline-primary" className="btn-block full-width mb-2" onClick={() => playAsGuest()}>Masuk Sebagai Guest</Button>
            <p className='mb-2'>Belum punya akun ? registrasi <a className='text-primary' onClick={() => setCurrentStep('register')}>disini</a></p>
            <Button variant="outline-primary" className="btn-block full-width" style={{ borderColor: 'rgba(0,0,0,0)' }} onClick={() => setCurrentStep('forgot-password')}>Lupa Password</Button>


        </>
    )
}